// Shared inline styles for the sign-in, profile, and account pages.
// Values follow the "Accounts" page in the 900 Pro Shop Paper file.

export const colors = {
  black: "#000000",
  teal: "#0891b2",
  cyan: "#22d3ee",
  page: "#f5f5f5",
  border: "#d4d4d4",
  muted: "#666666",
};

export const formStyle = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "400px",
  gap: "1.5rem",
};

export const titleStyle = {
  fontSize: "2rem",
  lineHeight: 1.2,
  fontWeight: 700,
  letterSpacing: "-0.02em",
  color: colors.black,
  margin: 0,
};

export const subtitleStyle = {
  fontSize: "1rem",
  lineHeight: 1.4,
  color: colors.muted,
  margin: "0.5rem 0 0",
};

export const fieldStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
};

export const labelRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  gap: "1rem",
};

export const labelStyle = {
  fontSize: "0.875rem",
  fontWeight: 600,
  color: colors.black,
};

export const hintStyle = {
  fontSize: "0.875rem",
  color: colors.muted,
};

export const inputStyle = {
  width: "100%",
  height: "48px",
  padding: "0 1rem",
  fontSize: "1rem",
  fontFamily: "inherit",
  color: colors.black,
  backgroundColor: "white",
  border: `1px solid ${colors.border}`,
  borderRadius: "10px",
  outline: "none",
};

export const primaryButtonStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.6rem",
  width: "100%",
  height: "52px",
  fontSize: "1rem",
  fontWeight: 700,
  fontFamily: "inherit",
  color: "white",
  background: `linear-gradient(90deg, ${colors.black} 0%, ${colors.teal} 100%)`,
  border: "none",
  borderRadius: "999px",
  cursor: "pointer",
};

export const googleButtonStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.75rem",
  width: "100%",
  height: "52px",
  fontSize: "1rem",
  fontWeight: 600,
  fontFamily: "inherit",
  color: colors.black,
  backgroundColor: "white",
  border: `1px solid ${colors.border}`,
  borderRadius: "999px",
  cursor: "pointer",
};

export const dividerStyle = {
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  fontSize: "0.75rem",
  fontWeight: 600,
  letterSpacing: "0.14em",
  color: "#888888",
};

export const dividerLineStyle = {
  flex: 1,
  height: "1px",
  backgroundColor: colors.border,
};

export const linkButtonStyle = {
  background: "none",
  border: "none",
  padding: 0,
  font: "inherit",
  fontWeight: 600,
  color: colors.teal,
  cursor: "pointer",
};

export const errorStyle = {
  backgroundColor: "#fef2f2",
  color: "#b91c1c",
  border: "1px solid #fecaca",
  borderRadius: "10px",
  padding: "0.75rem 1rem",
  fontSize: "0.9rem",
  lineHeight: 1.4,
};

export const noticeStyle = {
  backgroundColor: "#ecfeff",
  color: "#155e75",
  border: "1px solid #a5f3fc",
  borderRadius: "10px",
  padding: "0.75rem 1rem",
  fontSize: "0.9rem",
  lineHeight: 1.4,
};

export const finePrintStyle = {
  fontSize: "0.8rem",
  lineHeight: 1.5,
  color: colors.muted,
  textAlign: "center",
  margin: "-0.5rem 0 0",
};
